import axios from 'axios';

const getBudgets = (isBudgetOrder, config) => {
  return axios.get('/api/budget/all', {
    params: {
      isBudgetOrder: isBudgetOrder,
    },
    ...config
  });
};

const getAllBudgetsToCompare = (cancelToken) => {
  return axios.get('/api/budget/budget-compare', { cancelToken });
};

const getTwoBudgetsToCompare = (budgetOneId, budgetTwoId) => {
  return axios.get('/api/budget/compare-budgets', {
    params: {
      first_budget_id: budgetOneId,
      second_budget_id: budgetTwoId
    }
  });
};

const getFundsToCompare = (budgetId) => {
  return axios.get('/api/budget/fund-compare', {
    params: {
      budget_id: budgetId
    }
  });
};

const setActiveBudget = (data) => {
  return axios.post('/api/admin/setActiveBudget', data);
};

const saveAccessTypes = (data) => {
  return axios.post('/api/budget/save-access-types', data);
};

const newBudgetAsCopy = (data, config) => {
  return axios.post('/api/budget/copy', data, config);
};

const getAllBudgetsWithAccessType = () => {
  return axios.get('/api/budget/all-with-access-type');
};

const deleteBudget = (budgetId, config) => {
  return axios.delete('/api/budget/delete', {
    data : { 
      budgetId: budgetId 
    },
    ...config
  });
};

const createWorkingAndProposedBudgets = (data) => {
  return axios.post('/api/budget/create-working-and-proposed-budgets', data);
};

const validateBudgetForActivation = (data) => {
  return axios.post('/api/budget/validate-budget-for-activation', data);
};


const saveBudgetOrder = (budgetOrder, config) => {
  return axios.put('/api/budget/save-budget-order', budgetOrder, config);
};

const getCostTypeData = (cancelToken) => {
  return axios.get('/api/budget/cost-type', { cancelToken });
};

const getProgramCostDetails = (stopActiveCostCenterFiltration) => {
  if (stopActiveCostCenterFiltration) {
    return axios.get('/api/budget/program-cost-details', {
      params: {
        stopActiveCostCenterFiltration: stopActiveCostCenterFiltration
      }
    });
  } else {
    return axios.get('/api/budget/program-cost-details');
  }

};

const getCostCenterSummaryForBudget = (budgetId) => {
  return axios.get('/api/budget/cost-center-summary', {
    params: {
      budgetId: budgetId
    }
  });
};

const renameBudget = (budgetId, newBudgetName, newBudgetYear) => {
  return axios.post('/api/budget/rename-budget', {
    budgetId: budgetId,
    newBudgetName: newBudgetName,
    newBudgetYear: newBudgetYear,
  });
};

const publishBudgetToOpenPBB = (budgetId) => {
  return axios.post('/api/budget/publish', { budgetId: budgetId });
};

export {
  getBudgets,
  getAllBudgetsToCompare,
  getTwoBudgetsToCompare,
  getFundsToCompare,
  setActiveBudget,
  saveAccessTypes,
  newBudgetAsCopy,
  getAllBudgetsWithAccessType,
  deleteBudget,
  createWorkingAndProposedBudgets,
  validateBudgetForActivation,
  getCostTypeData,
  getProgramCostDetails,
  getCostCenterSummaryForBudget,
  saveBudgetOrder,
  renameBudget,
  publishBudgetToOpenPBB
};
